// src/store/profileSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  phone: "",
  role: "",
  price: "",
  profileImage: "",
  isProfileLoaded: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        isProfileLoaded: true,
      };
    },

    updateProfileField: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },

    clearProfile: () => initialState,
  },
});

export const {
  setProfileData,
  updateProfileField,
  clearProfile,
} = profileSlice.actions;

export default profileSlice.reducer;
